/**
 * O que aconteceu com as edições de texto quando o dado mudou (E203.F3, ADR-0146 §5): salvar um
 * dado gera uma análise nova; a edição cujo trecho original é o mesmo segue no documento sozinha
 * (a herança da ADR-0136 §1), e a de trecho mudado fica no fim do documento para conferir. No alto
 * do documento, uma linha diz quantas seguiram e quantas pedem conferência, com o caminho até elas.
 */
import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { DocumentoDaSaidaData } from '@/lib/documentoDaSaida';

const t = ptBR.painelDoDado.analiseNova;

export const ID_DAS_EDICOES_FORA = 'edicoes-fora-do-documento';

/** As edições de uma análise anterior que mudam o texto e seguem no documento desta. */
export function seguiram(documento: DocumentoDaSaidaData): number {
  return documento.trechos.filter(
    (x) =>
      x.vigente !== null &&
      x.vigente.avaliacao_id !== documento.avaliacao_id &&
      x.vigente.acao !== 'restaurar',
  ).length;
}

function contar(n: number, um: string, varios: string): string {
  return (n === 1 ? um : varios).replace('{n}', String(n));
}

export function AvisoDaAnaliseNova({
  documento,
}: {
  documento: DocumentoDaSaidaData;
}): JSX.Element | null {
  const mudaram = documento.desatualizadas.length;
  const foram = seguiram(documento);
  if (mudaram === 0 && foram === 0) return null;
  return (
    <div
      role="status"
      className={`mb-sc-2 flex flex-wrap items-center gap-sc-2 text-body-sm ${mudaram > 0 ? 'text-warning-700' : 'text-fg-muted'}`}
      data-testid="aviso-da-analise-nova"
    >
      {foram > 0 ? <span>{contar(foram, t.seguiuUm, t.seguiram)}</span> : null}
      {mudaram > 0 ? <span>{contar(mudaram, t.mudouUm, t.mudaram)}</span> : null}
      {mudaram > 0 ? (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={() =>
            document
              .getElementById(ID_DAS_EDICOES_FORA)
              ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
          data-testid="aviso-da-analise-nova-conferir"
        >
          {t.conferir}
        </Button>
      ) : null}
    </div>
  );
}
